module.exports = __webpack_public_path__ + "57023915e931d6b7cf5cca6945bfbca5.png";